import {
  STATUS_APPROVED,
  STATUS_COMPLETED,
  STATUS_DECLINED,
  STATUS_FAILED,
  STATUS_INITIATED,
  STATUS_PENDING,
  STATUS_PENDING_APPROVAL,
  STATUS_PROCESSING,
  STATUS_REFUNDED,
  STATUS_REJECTED,
  STATUS_VOIDED,
  STATUS_WITHDRAWN
} from '@library/constants/payments';

export interface StatusIconProps {
  status: string;
  classes?: string;
}

export const StatusIcon = ({
  status,
  classes = 'align-middle'
}: StatusIconProps) => {
  const getBackgroundColor = () => {
    switch (status) {
      case STATUS_APPROVED:
        return 'bg-status-success';
      case STATUS_COMPLETED:
        return 'bg-status-success';
      case STATUS_WITHDRAWN:
        return 'bg-status-success';
      case STATUS_PENDING:
      case STATUS_PENDING_APPROVAL:
        return 'bg-status-info';
      case STATUS_PROCESSING:
        return 'bg-status-warning';
      case STATUS_FAILED:
        return 'bg-status-failure';
      case STATUS_DECLINED:
        return 'bg-status-caution';
      case STATUS_INITIATED:
        return 'bg-status-info';
      case STATUS_REFUNDED:
        return 'bg-status-neutral';
      case STATUS_REJECTED:
        return 'bg-status-failure';
      case STATUS_VOIDED:
        return 'bg-status-failure';
      default:
        return 'bg-status-default';
    }
  };

  return (
    <div
      className={`${getBackgroundColor()} mr-1 inline-block size-3 rounded-full ${classes}`}
    />
  );
};
